import React, { useState } from "react";
import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { classNames } from 'primereact/utils';
import { Password } from 'primereact/password';
import { Divider } from 'primereact/divider';
import { Panel } from 'primereact/panel';
import {
    Form,
    redirect,
    useSubmit,
    useLoaderData,
} from "react-router-dom";
import { useFormik } from 'formik';
import { update, getAccount, testBinancebConnect, testBitgetConnect } from "../data/accounts";
import { getCurrentSubscription } from "../data/auth.service";
import { send, notify } from "../services/NotificationService";
import { IsNullOrEmpty } from "../services/CustomService";

import { Avatar } from 'primereact/avatar';
export async function loader({ params }) {
    const acc = await getAccount();
    const sub = await getCurrentSubscription();

    return { acc, sub };
}
export async function action({ request, params }) {
    const formData = await request.formData();
    const data = Object.fromEntries(formData);

    await update(data);

    send("success", "Modifications effectuées !")
    return redirect(`/moncompte`);
}

export default function Account() {
    const { acc, sub } = useLoaderData();
    const [value, setValue] = useState('');
    const header = <div className="font-bold mb-3">Choisir un mot de passe</div>;


    const footer = (
        <>
            <Divider />
            <ul className="pl-2 ml-2 mt-0 line-height-3">
                <li>Au moins une minuscule</li>
                <li>Au moins une majuscule</li>
                <li>Au moins un chiffre</li>
                <li>Au moins un caractère non-alphanumérique</li>
                <li>Minimum 6 caractères</li>
            </ul>
        </>
    );

    var email, address, zipcode, city, phone, fname, lname, subscriptionActivate, binanceKey = "";
    if (acc) {
        email = acc.email;
        address = acc.address;
        zipcode = acc.zipcode;
        city = acc.city;
        phone = acc.phone;
        fname = acc.firstname;
        lname = acc.lastname;
        subscriptionActivate = acc.subscription;
        binanceKey = acc.binanceApiKey;

    }

    // Formik ---------------------
    const submit = useSubmit();
    const formik = useFormik({
        initialValues: {
            email: email ?? '',
            currentPwd: '',
            newPwd: '',
            address: address ?? '',
            zipcode: zipcode ?? '',
            city: city ?? '',
            phone: phone ?? '',
            fname: fname ?? '',
            lname: lname ?? '',
            subscriptionActivate: subscriptionActivate === "1" ? true : false,
            binanceKey: binanceKey ?? '',

        },
        validate: (data) => {
            let errors = {};

            if (data.newPwd && data.newPwd !== data.confirmPwd) {
                errors.newPwd = 'Les mots de passe ne correspondent pas';
            }

            return errors;
        },
        onSubmit: async (data) => {
            submit(data, { method: "post" })
        }
    });

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);


    const testBinanceConnectAction = () => {

        // recuperation user et mdp
        var key = formik.values.binanceKey;
        var secret = formik.values.binanceSecret;

        if (IsNullOrEmpty(key) || IsNullOrEmpty(secret)) {
            send("error", "Merci de remplir tous les champs")
            notify();
            return;
        }

        let a = testBinancebConnect(key, secret);
        a.then((a) => {
            if (a === true)
                send("success", "La connexion semble fonctionner ! Les paramètres ont été enregistrés.")
            else
                send("error", "Il semble y avoir un souci. Merci de vérifier vos données")
            notify();
        });

        notify();
    };
    const testBitgetConnectAction = () => {

        // recuperation user et mdp
        var key = formik.values.bgKey;
        var secret = formik.values.bgSecret;
        var pass = formik.values.bgPass;

        if (IsNullOrEmpty(key) || IsNullOrEmpty(secret)) {
            send("error", "Merci de remplir tous les champs")
            notify();
            return;
        }

        let a = testBitgetConnect(key, secret, pass);
        a.then((a) => {
            if (a === true)
                send("success", "La connexion semble fonctionner !")
            else
                send("error", "Il semble y avoir un souci. Merci de vérifier vos données")
            notify();
        });


        notify();
    };
    
    return (
        <div >
            <h1>Mon compte</h1>

            <Form method="post" id="thumbnail-form" onSubmit={formik.handleSubmit}>
                <Panel header="Identit&eacute;">
                    <div className="contentForm">
                        <span className="p-float-label">
                            <InputText id="fname" name="fname" value={formik.values.fname}
                                onChange={(e) => {
                                    formik.setFieldValue('fname', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('fname') })}
                            />
                            <label htmlFor="fname">Pr&eacute;nom</label>
                        </span>

                        <span className="p-float-label">
                            <InputText id="lname" name="lname" value={formik.values.lname}
                                onChange={(e) => {
                                    formik.setFieldValue('lname', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('lname') })}
                            />
                            <label htmlFor="lname">Nom</label>
                        </span>
                    </div>
                    <div className="contentForm">
                        <span className="p-float-label">
                            <InputText disabled id="email" name="email" value={formik.values.email}
                                onChange={(e) => {
                                    formik.setFieldValue('email', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('email') })}
                            />
                            <label htmlFor="email">Email</label>
                        </span>
                    </div>
                    <div className="contentForm"></div >
                </Panel>
                <div className="contentForm"></div >
                <Panel header="Mot de passe">
                    <div className="contentForm">
                        <span className="p-float-label">

                            <Password id="currentPwd" name="currentPwd" value={formik.values.currentPwd}
                                feedback={false}
                                onChange={(e) => {
                                    formik.setFieldValue('currentPwd', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('currentPwd') })}
                            />
                            <label htmlFor="currentPwd">Mot de passe actuel</label>
                        </span>
                        <div className="card flex justify-content-center">
                            <span className="p-float-label">

                                <Password id="newPwd" name="newPwd" value={formik.values.newPwd} header={header} footer={footer}
                                    promptLabel=" " weakLabel="Trop simple" mediumLabel="Moyennement complexe" strongLabel="Très complexe !"

                                    onChange={(e) => {
                                        formik.setFieldValue('newPwd', e.target.value);
                                        setValue(e.target.value)
                                    }}
                                    className={classNames({ 'p-invalid': isFormFieldInvalid('newPwd') })}
                                />
                                <label htmlFor="newPwd">Nouveau</label>
                            </span>
                        </div>
                        <span className="p-float-label">

                            <Password id="confirmPwd" name="confirmPwd" value={formik.values.confirmPwd}
                                feedback={false}
                                onChange={(e) => {
                                    formik.setFieldValue('confirmPwd', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('confirmPwd') })}
                            />
                            <label htmlFor="confirmPwd">Confirmation</label>
                        </span>
                    </div>
                    <div className="contentForm"></div >
                </Panel>
                
                <div className="contentForm"></div >
                <Panel className="module" header="Clés API" >


                    <div className="contentForm">
                        <div className="serviceTitle">

                            <Avatar image="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAVWSURBVFhHzZldbJNVGICf92vpfjt0ZRD5uQPmVDZwUwbEEEmEDY1EvUFh/M0YJYQb42AqLNPwt+gNMbAYJoKCJAYSLwQ3I8YLkZ8t8iOZENSLRY0xRVm7devW7/Vi69ae9uu6OhKeu++8b0+fnvO95zvfqZABqljdX8973CXypNpSoWixiDygql4AEQmo6p+C3BBL2yOq3xZ8f+2iNGKbfY2FmA2p6P3q4VkRcW9GtAZkhhlPjf6OyicuHTyQW3W9y4w6kZZg9+n5RerSRkuoBTxmfJyEbaVFItJQsPLy32bQZEzBQGvpapAPEHxm7H+h6ge2eFdcPWGGYnEU1PbySUH/4H6EV83YhKI05/vcW6WiY8AM4SRon6vM6QmGTgLVZuwucSYvP+cFa/H5kBlIENT28knB24NfZCLX06eoQn5OQrfpcCa/0L3KHEkr9gIg6B/cn6nc+r1+1u/zEwypGU6H6uHvjiPupwZaS1cj8llsWzr0hJT1+/y03wwDUD7Xw5FtvsxGUvXF2MIZ6aH79PwicWnneKvVlIuSsaTi14iURJegkSkWlzaOVy7oIAfQcTOc2XQLPnVp4+hl9AlhuW+NZxEOhpQNDnKxZDiSYZc9ODu36nqXBRCx3JsnQi43S8jNjhfJcCQ9w05Y2oClquvMDCdSyR2u83H4DR+5WRMhqTXagCV32uZVWlg/mOFk9IeVNbud5RaWDE3Chc4wG5v89PbHC5XP9XDsTR/ZnvSm28ZeZAksMwNOZHmEBXPi7wRTDmBhiYfDdYkjuWC2J205hgpkmSVqlZuBVLy1poBXnskHB7kopuTLK/N5e22BmZYSUavcVV8zbaeITDWDUYIhpfa920yf4mJmkRuAJ+ZlEbFh63PeOLldx7r57kofS8uyAZhZ5KK8OIup91vUvzQqd6EzTP2hf1lekYNnkvOIKmpLoK3MDxSaQWLWuY6bYXKzhI/qfFQmGS2A3ce6+fDLIAC1K/PYsXaymQLG/ZnGEnTbim7TTWLlAHr7lU1Nfi50Jq57e46PygG0nO7h3U/vxOUAnO/sjyuesapbVb0Jm4UoIolbHQVsTexsMJLYpknePiRJp0m6i8MSkYDZCJCXLRzZ7qOieGhKhwqikEUPZZmp7KiZTO3KvJHrTdV57FyXOMULH/TwcZ1vZDEvn+vh6HbnKRaRgKt+7bR1TkXicQtPV+bw028D7Kq9j8qSUbn3Pw/gsoSZRS4AlpZmEwjZLJjtYWfNqNylG2GOf9PDkkeGPjtjiovHirP4658Ih153lmNoin+VQGvZSYTnzWAqogWRapkBuPRzmA1Nfnr6lNrqPHbEiKeFcspSsTvM9lTsiqnW3n5lo0PhXIyRA2g508M7R+8wxi0Xh4rdYSmcNQNO9A8oP96Kl0kmacpFufzLAP3h9BUVzooqVqCttEtEppsJyejpG94D3kj+PBaBDU1+eg25R+ekLggTVf3De+7qLAEItJXtAbabSU6kkkT433LD7PUuv1JvAbjswQNA4o3kQF62cGTb6BIUpbdfJ0ouPOw0tOXPrbrehdJiZqXCSTKWsdY5J2ylJXp+M/Ik0Yg0oPjjMscglWQaz9nkKH6JSEP0ckRw6C1Kt4wkpkkyyYzlANAtsYdKCT0EWssOZnIeE31xV8hcTmn2rrjyWmxTQi/32tFH0p7sc5U5wUDolAhVZuwu4Xh4lHS7ZS0+H/L63M+iNJuxCUdpzi90r0omh9MIxnL3DjDxg455gJl0BGPxrrh6QiNSYisHx7OYpyBsKwc1IiVjyZHOCMZyzx6im2gDVveScf4N8dS1iyLj/xviP0ysrA26PC10AAAAAElFTkSuQmCC" size="large" shape="circle" />
                            <span className="font-bold"></span>
                        </div>

                        <span className="p-float-label">
                            <InputText id="binanceKey" name="binanceKey" value={formik.values.binanceKey}
                                onChange={(e) => {
                                    formik.setFieldValue('binanceKey', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('binanceKey') })}
                            />
                            <label htmlFor="binanceKey">Key</label>
                        </span>

                        <span className="p-float-label">
                            <Password id="binanceSecret" name="binanceSecret" value={formik.values.binanceSecret}
                                feedback={false}
                                onChange={(e) => {
                                    formik.setFieldValue('binanceSecret', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('binanceSecret') })}
                            />
                            <label htmlFor="binanceSecret">Secret</label>
                        </span>
                        <span className="p-float-label">
                            <Button size="small" type="button" onClick={() => testBinanceConnectAction()} severity="secondary">Test</Button>
                        </span>
                    </div>
                    

                    <div className="contentForm">
                        <div className="serviceTitle">

                            <Avatar image="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAACxMAAAsTAQCanBgAAARCSURBVFhHzZlNbBRlGMd/73TbmakHu7NqNCbEePHmAREp5UNAqRT8CvHEwViwDS1tqVrUaLiYIAJqoR8qH1I1JnooAYRCC9gWWhATOXjzpOEEyu7Wg+xO253Xw+6UzuvO7my7lf5uff5Pk19m9n3ezbMCFSkNxuQmYCPwBHAfQmhqW1GQ0gFuAb8AvVSIbxEiOb1FTP+DMacaOAhigaf+vyGvA3VUaP1u5c6TGXPqkfTdPTkAsQBJH2NO/VQFMk9O0jdnr7JQpHQQ1FCh9QukNPhb/nZ3n1w25HXuFY8J4s5mhDisxkEwBgewWusRExNqBJrG2M4P+eeVTWoSHCm3aJnTWjDG0LmccvEP9s1OLs1GQdy5iRAPqEkujKHzWNvrEBPjagQlJcR3tXN7w8tqMgPkTUEslULTAh8OY/gC1vbXEePZ5WK795OoeUlNZobjOFpBchd/zC33UUfx5AC0QuQuDWK1+MmFiO3pJLHuBTWZNYEEjZFBrOYtiHFbjSAUIra3k8Rzz6tJUcgraIwO+crJUIjY3i4S1RvUqGjkFNRHh7GaNiPsbHKlxPd1k1i7Xo2Kiq+gfvkiET+50lLiH3eTeLZGjYqOYExKtQjw4KpFlPx5Qy0DEN/Twe313jmnxW4R+uN3T20KAeOPL4SSEjXJi6+g1daI2XdCLQNgL64k2v010jSnasK2iTTVoo8Oe3pdEjUvEtt9oGBJ31cc39VOcvVatQyA/vMVIo2vIpKJqZrUdaIdR7CXrvD0uph9J7DeboLUpBrlxFdQlpYS++QLkmuq1QgA/eplIo2vKZIG0c4vsSuXe3pdzDMnsXY0wWRwSV9BpiQ/J/HMOjUCQP9phMi2WkTyzrf0tORR7CXLPL0u5tkfsHZsCyyZUxB3nOQ4sfqVS0SaahH2NEnDINp1FPupKk+vi9l/CqutERFAMq8gAWZetpEkDZNoVw/24qWeXhdz4DTht7YiJrN8XZtGIEEC3Br66DBWsyJpmkS7e7CfrPT0upjnzhB+Y2v275QZAgtC/nvXGBnCavFei9IsJ/rZV9iLlnh6XcwLZ6l4/021PIXvHMxJKkXZr9fA5z8nH3kUx4p4auUnewm/2+KpuaQeepgb56+qZZixYIGYA32E2xqyHor0gerxPfWFveIZkD6xPnJ5RhJzLZhr5uUb6i5zJpjr1sh3LU5nTgRz3btS14l1HMGuWqlGWSm6YPnp41jvNEMqpUbIMp3YgcMkq55WI1+0zAqsKJSfOpYeJbnklq1SI3+kdLTMfm7WpOdcq49cGbH9h0guL0AOQPCXllkezoryY98Rfq8VHB+59kMkV6xWo/xIrmlAr1ovhHu+/4bwzjZw/vtJkaVlxD49SHLlGjUKSu+8X79pmZ1wXTEPy6xJu9QhRDI9Ziq0fgQN80IyvV1tcPfU836J7hUE788QgoVI7p+z3XWAnyH+BSKmyvMYDIfSAAAAAElFTkSuQmCC" size="large" shape="circle" />
                            <span className="font-bold"></span>
                        </div>

                        <span className="p-float-label">
                            <InputText id="bgKey" name="bgKey" value={formik.values.bgKey}
                                onChange={(e) => {
                                    formik.setFieldValue('bgKey', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('bgKey') })}
                            />
                            <label htmlFor="bgKey">Key</label>
                        </span>

                        <span className="p-float-label">
                            <Password id="bgSecret" name="bgSecret" value={formik.values.bgSecret}
                                feedback={false}
                                onChange={(e) => {
                                    formik.setFieldValue('bgSecret', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('bgSecret') })}
                            />
                            <label htmlFor="bgSecret">Secret</label>
                        </span>
                        <span className="p-float-label">
                            <Password id="bgPass" name="bgPass" value={formik.values.bgPass}
                                feedback={false}
                                onChange={(e) => {
                                    formik.setFieldValue('bgPass', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('bgPass') })}
                            />
                            <label htmlFor="bgPass">Pass</label>
                        </span>
                        <span className="p-float-label">
                            <Button size="small" type="button" onClick={() => testBitgetConnectAction()} severity="secondary">Test</Button>
                        </span>
                    </div>

                    <div className="contentForm"></div>
                </Panel>

               
                <p> <Button type="submit" size="small">Enregistrer</Button></p>
                <div className="contentForm"></div >
            </Form>
        </div>
    );
}